module.exports = __webpack_public_path__ + "img/fc.99f35d13.png";